import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconArrowUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 18,
	height: 18,
	viewBox: "0 0 18 18",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M8.5625 3.93457L3.96875 8.52832C3.69531 8.77441 3.69531 9.18457 3.96875 9.45801C4.21484 9.7041 4.625 9.7041 4.89844 9.45801L8.37109 5.98535V14.0869C8.37109 14.4424 8.64453 14.7432 9.02734 14.7432C9.38281 14.7432 9.68359 14.4424 9.68359 14.0869V5.98535L13.1562 9.45801C13.4023 9.7041 13.8125 9.7041 14.0586 9.45801C14.332 9.21191 14.332 8.77441 14.0586 8.52832L9.46484 3.93457C9.21875 3.68848 8.80859 3.68848 8.5625 3.93457Z",
		fill: "white"
	})
});
export default SvgIconArrowUp;
